export const Short_Name_Length = 20;
export const Aadhaar_Workflow_Display_Name = "AADHAAR";
export const relationship_others = "Others";
export const relationship_mother = "Mother";
export const relationship_father = "Father";
export const relationship_nan = "NAN";
export const App_Name = "kyc";
export const Yes = "Yes";
export const No = "No";
export const PERSONALINFO_Widget = "PERSONALINFO";
export const NOMINEE_Widget = "NOMINEE";
export const BANKVF_Widget = "BANKVF";
export const VideoKYC_Widget = "VIDEOKYC";
export const NOMINEE_1 = "NOMINEE 1";
export const NOMINEE_2 = "NOMINEE 2";
export const ENTRY_MODE = "ENTRY";
export const VIEW_MODE = "VIEW";
export const CHECKER_MODE = "CHECKER";
export const NONE = "NONE";
export const OK = "OK";
export const CANCEL = "CANCEL";
export const DELETE = "DELETE";
export const OKCANCEL = "OKCANCEL";
export const DELETECANCEL = "DELETECANCEL";
export const Accepted = "ACCEPTED";
export const keyPersonalInfo = "Key Personal Info";
export const additionalPersonalInfo = "Additional Personal Info";
export const taxDeclaration = "Tax Declaration";
export const addressChange = "Address Change";
export const Pass = "Pass";
export const Fail = "Fail";
export const signatureUpload = "Signature Upload";
export const MaxFileSizeToUpload = 5;
export const TermsAndConditions = "TermsAndConditions.pdf";
export const CKYCImage = "CKYCImage.pdf";
export const defaultMobileCountryCode = "91";
